import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <motion.header
      className={`fixed w-full z-[60] transition-all duration-700 ${
        scrolled ? 'bg-ivory/95 backdrop-blur-md shadow-sm py-4' : 'bg-transparent py-5 md:py-8'
      }`}
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 1, ease: "easeOut" }}
    >
      <div className="max-w-7xl mx-auto px-6 flex justify-between items-center">
        <div className={`text-lg md:text-2xl tracking-[0.3em] font-serif transition-colors duration-500 ${
          scrolled ? 'text-olive' : 'text-white'
        }`}>
          PADUA WEDDINGS
        </div>
        
        <nav className="hidden md:flex items-center gap-8">
          <button 
            onClick={() => document.getElementById('contact-section')?.scrollIntoView({ behavior: 'smooth' })}
            className={`text-[10px] uppercase tracking-[0.3em] font-medium transition-all duration-500 ${
              scrolled ? 'text-olive hover:text-gold' : 'text-white/90 hover:text-white'
            }`}
          >
            Inquire Now
          </button>
        </nav>
      </div>
    </motion.header>
  );
}